/**
 * FORMATAÇÃO DE DATA — FORMATO BRASIL (dd/mm/aaaa)
 *
 * O sistema grava a data do campeonato em ISO, porque o campo é um
 * `<input type="date">` (que produz `AAAA-MM-DD`). A landing mostrava a string
 * crua, então o visitante lia "2026-09-22" em vez de "22/09/2026".
 *
 * POR QUE NÃO USAR `new Date(iso).toLocaleDateString('pt-BR')`:
 * `new Date('2026-09-22')` é interpretado como meia-noite em UTC. Em
 * America/Sao_Paulo (UTC-3) isso vira 21/09/2026 às 21h — ou seja, o
 * `toLocaleDateString` mostraria **21/09/2026**: um dia A MENOS. O mesmo erro
 * aparece em qualquer fuso a oeste de Greenwich.
 *
 * Por isso a conversão é textual: a data civil é o que está escrito na string,
 * e ela não deve depender do fuso de quem está olhando.
 */

const ISO_CURTA = /^\d{4}-\d{2}-\d{2}$/;

/**
 * `2026-09-22` (ou `2026-09-22T00:00:00.000Z`) -> `22/09/2026`.
 *
 * Devolve string vazia para valor ausente e devolve o valor como veio quando o
 * formato não é reconhecido — melhor mostrar algo estranho do que apagar a data
 * de um campeonato.
 */
export function formatarDataBR(iso) {
  if (!iso) return '';

  const dia = String(iso).slice(0, 10);
  if (!ISO_CURTA.test(dia)) return String(iso);

  const [ano, mes, diaDoMes] = dia.split('-');
  return `${diaDoMes}/${mes}/${ano}`;
}
